import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

const container = document.getElementById('root')!;

// If the prerenderer (Phase 1A) wrote markup into the root, hydrate;
// otherwise mount fresh. This makes the same bundle work for both the
// SPA fallback and pre-rendered routes.
if (container.hasChildNodes()) {
  hydrateRoot(container, <App />);
} else {
  createRoot(container).render(<App />);
}

// Tell @prerenderer/rollup-plugin we're done painting, so it captures the
// fully rendered DOM. We dispatch on the next animation frame to give
// Helmet, react-router, and the carousel a tick to mount.
if (typeof window !== 'undefined') {
  requestAnimationFrame(() => {
    document.dispatchEvent(new Event('render-event'));
  });
}
